(()=>{
  const initProductPurchase=root=>{
    if(!root||root.dataset.akPurchaseReady==='true')return;
    root.dataset.akPurchaseReady='true';

    const form=root.querySelector('.ak-product-form');
    const addButton=form?.querySelector('.ak-add-cart');
    const variantSelect=form?.querySelector('[data-ak-variant-select]');
    const quantityInput=form?.querySelector('.ak-product-quantity');
    const paymentWrap=form?.querySelector('.ak-buy-now');
    if(!form||!addButton)return;

    const defaultVariantAvailable=!addButton.disabled;
    const shopRoot=window.Shopify?.routes?.root||'/';
    const route=path=>`${shopRoot}${path}`.replace(/\/+/g,'/');

    let status=form.querySelector('.ak-product-purchase-status');
    if(!status){
      status=document.createElement('p');
      status.className='ak-product-purchase-status';
      status.setAttribute('role','status');
      status.setAttribute('aria-live','polite');
      addButton.insertAdjacentElement('afterend',status);
    }

    let directBuy=form.querySelector('[data-ak-direct-buy-now]');
    if(!directBuy){
      directBuy=document.createElement('button');
      directBuy.type='button';
      directBuy.className='ak-direct-buy-now';
      directBuy.dataset.akDirectBuyNow='true';
      directBuy.textContent='BUY NOW';
      if(paymentWrap)paymentWrap.insertAdjacentElement('beforebegin',directBuy);
      else form.appendChild(directBuy);
    }

    /* Amazon CTA: show on every beef-jerky and bacon-jerky product detail page. */
    const productTitle=(root.querySelector('.ak-product-info h1')?.textContent||'').trim().toLowerCase();
    const isJerkyProduct=productTitle.includes('beef jerky')||productTitle.includes('bacon jerky');
    let amazonBuy=form.querySelector('[data-ak-amazon-buy]');
    if(isJerkyProduct&&!amazonBuy){
      amazonBuy=document.createElement('a');
      amazonBuy.className='ak-amazon-buy';
      amazonBuy.dataset.akAmazonBuy='true';
      amazonBuy.href='https://www.amazon.com/s?me=AVAZFZ3DL516M&marketplaceID=ATVPDKIKX0DER';
      amazonBuy.setAttribute('aria-label','New on Amazon — click here to buy now and get a free gift');
      amazonBuy.innerHTML=`
        <span class="ak-amazon-buy__brand" aria-hidden="true">
          <span class="ak-amazon-buy__word">amazon</span>
          <svg class="ak-amazon-buy__smile" viewBox="0 0 70 16" role="presentation" focusable="false">
            <path d="M4 4c16 10 38 11 61 1" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round"/>
            <path d="M59 2l7 3-4 6" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="ak-amazon-buy__copy">
          <span class="ak-amazon-buy__eyebrow">NEW ON AMAZON</span>
          <span class="ak-amazon-buy__line">CLICK HERE TO BUY NOW <span class="ak-amazon-buy__gift">+ GET A FREE GIFT</span></span>
        </span>
        <span class="ak-amazon-buy__recommend" aria-hidden="true">
          <span class="ak-amazon-buy__recommend-text">HIGHLY<br>RECOMMENDED</span>
          <span class="ak-amazon-buy__recommend-fire">🔥</span>
        </span>`;
      directBuy.insertAdjacentElement('afterend',amazonBuy);
    }

    let amazonNote=form.querySelector('[data-ak-amazon-note]');
    if(isJerkyProduct&&amazonBuy&&!amazonNote){
      amazonNote=document.createElement('div');
      amazonNote.className='ak-amazon-note';
      amazonNote.dataset.akAmazonNote='true';
      amazonNote.setAttribute('role','note');
      amazonNote.setAttribute('aria-label','At Amazon checkout, click gift option. Type free gift for a free gift, or type free jerky for a free jerky bag.');
      amazonNote.innerHTML=`
        <span style="display:block;color:#fff;-webkit-text-fill-color:#fff;font-weight:1000;line-height:1.05;font-size:clamp(7.2px,1vw,8.8px);letter-spacing:.035em;">AT AMAZON CHECKOUT: CLICK GIFT OPTION</span>
        <span style="display:block;color:#fff;-webkit-text-fill-color:#fff;font-weight:1000;line-height:1.05;font-size:clamp(6.9px,.95vw,8.5px);letter-spacing:.018em;">TYPE <span style="color:#ffd21c;-webkit-text-fill-color:#ffd21c;">“FREE GIFT”</span> FOR A FREE GIFT</span>
        <span style="display:block;color:#fff;-webkit-text-fill-color:#fff;font-weight:1000;line-height:1.05;font-size:clamp(6.9px,.95vw,8.5px);letter-spacing:.018em;">OR TYPE <span style="color:#ffd21c;-webkit-text-fill-color:#ffd21c;">“FREE JERKY”</span> FOR A FREE JERKY BAG</span>`;
      amazonNote.style.cssText='position:relative;z-index:5;width:calc(100% - (var(--ak-purchase-gutter,10px) * 2));max-width:calc(100% - (var(--ak-purchase-gutter,10px) * 2));min-height:38px;margin:4px auto 0;padding:5px 8px;box-sizing:border-box;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1px;border:1px solid #f0cd36;border-radius:6px;background:linear-gradient(180deg,#ff2d2d 0%,#e20d0d 48%,#a10606 100%);color:#fff;-webkit-text-fill-color:#fff;text-align:center;font-family:Arial,Helvetica,sans-serif;text-transform:uppercase;box-shadow:0 2px 7px rgba(0,0,0,.22),inset 0 1px 0 rgba(255,255,255,.22);text-shadow:0 1px 1px rgba(80,0,0,.48);pointer-events:none;';
      amazonBuy.insertAdjacentElement('afterend',amazonNote);
    }

    const currentVariant=()=>{
      if(variantSelect)return variantSelect.value;
      return form.querySelector('input[name="id"]')?.value||'';
    };

    const currentQuantity=()=>{
      const parsed=parseInt(quantityInput?.value||'1',10);
      return Number.isFinite(parsed)&&parsed>0?parsed:1;
    };

    const selectedAvailable=()=>{
      if(!variantSelect)return defaultVariantAvailable;
      const option=variantSelect.options[variantSelect.selectedIndex];
      return !!option&&!option.disabled;
    };

    const syncPaymentClickability=()=>{
      if(!paymentWrap)return;
      paymentWrap.style.pointerEvents='auto';
      paymentWrap.style.position='relative';
      paymentWrap.style.zIndex='8';
      paymentWrap.querySelectorAll('.shopify-payment-button,.shopify-payment-button__button,.shopify-payment-button__more-options').forEach(el=>{
        el.style.pointerEvents='auto';
        el.style.position='relative';
        el.style.zIndex='9';
      });
    };

    const syncState=()=>{
      const available=selectedAvailable();
      addButton.disabled=!available;
      directBuy.disabled=!available;
      addButton.textContent=available?'ADD TO CART':'SOLD OUT';
      directBuy.textContent=available?'BUY NOW':'SOLD OUT';
      syncPaymentClickability();
    };

    const setBusy=(button,busy,label)=>{
      button.disabled=busy||!selectedAvailable();
      button.setAttribute('aria-busy',busy?'true':'false');
      if(busy)button.textContent=label;
      else syncState();
    };

    const addSelected=async()=>{
      const variantId=currentVariant();
      if(!variantId)throw new Error('Please choose an available option.');
      const payload=new FormData();
      payload.append('id',variantId);
      payload.append('quantity',String(currentQuantity()));

      /* Preserve product-line properties and selling-plan fields if present. */
      new FormData(form).forEach((value,key)=>{
        if(key==='id'||key==='quantity')return;
        payload.append(key,value);
      });

      const response=await fetch(route('cart/add.js'),{
        method:'POST',
        headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:payload,
        credentials:'same-origin'
      });
      if(!response.ok){
        let message='This item could not be added. Please try again.';
        try{
          const data=await response.json();
          message=data?.description||data?.message||message;
        }catch(_){/* use fallback */}
        throw new Error(message);
      }
      return response.json();
    };

    /*
      PDP ADD TO CART stays on the product page and uses Shopify's AJAX cart API.
      Essential Apps remains responsible for detecting the cart mutation and
      opening its native cart/upsell funnel. We do not style, replace or
      manually open any EA interface here.
    */
    let addInFlight=false;
    const submitAddToCart=async event=>{
      event?.preventDefault?.();
      event?.stopPropagation?.();
      if(addInFlight||!selectedAvailable())return;

      addInFlight=true;
      addButton.setAttribute('aria-busy','true');
      status.textContent='';

      try{
        await addSelected();
      }catch(error){
        console.error('[AK product add to cart]',error);
        status.textContent=error?.message||'Unable to add this item. Please try again.';
      }finally{
        addInFlight=false;
        addButton.removeAttribute('aria-busy');
        syncState();
      }
    };

    addButton.addEventListener('click',submitAddToCart);
    form.addEventListener('submit',event=>{
      if(event.submitter&&event.submitter!==addButton)return;
      submitAddToCart(event);
    });

    directBuy.addEventListener('click',async event=>{
      event.preventDefault();
      if(!selectedAvailable())return;
      setBusy(directBuy,true,'OPENING CHECKOUT…');
      status.textContent='Preparing checkout…';
      try{
        await addSelected();
        window.location.assign(route('checkout'));
      }catch(error){
        console.error('[AK product buy now]',error);
        status.textContent=error?.message||'Unable to start checkout. Please try again.';
        setBusy(directBuy,false,'BUY NOW');
      }
    });

    variantSelect?.addEventListener('change',()=>{
      status.textContent='';
      syncState();
      /* Shopify accelerated checkout listens to normal product-form state changes. */
      variantSelect.dispatchEvent(new Event('input',{bubbles:true}));
    });
    quantityInput?.addEventListener('change',()=>{
      if(currentQuantity()<1)quantityInput.value='1';
      status.textContent='';
      syncState();
    });

    /* Payment buttons are injected asynchronously by Shopify. Keep them click-safe when they appear. */
    if(paymentWrap&&'MutationObserver' in window){
      new MutationObserver(syncPaymentClickability).observe(paymentWrap,{childList:true,subtree:true});
    }

    root.addEventListener('pointerdown',event=>{
      if(event.target.closest?.('.shopify-payment-button,.shopify-payment-button__button'))syncPaymentClickability();
    },true);

    syncState();
  };

  const initAll=(scope=document)=>scope.querySelectorAll?.('[data-ak-product-page]').forEach(initProductPurchase);
  document.addEventListener('DOMContentLoaded',()=>initAll(document));
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  window.addEventListener('pageshow',()=>initAll(document));
})();